import { Box, Divider, Heading } from '@chakra-ui/react';
import { responsiveValue } from '../../../assets/style/defaultTheme';
import { ActivityFullContent } from './style';

const { flexBoxDirection, participationSideBoxWidth, participationContentBoxWidth } = responsiveValue;

type Props = {
  data:any;
};

function ParticipationContentItemActivityFull({ data }: Props) {

  return (
    <>
    {
      data.map((item:any, index:number) => (
        <Box key={index}>
          <Heading size="lg" color="b.dgr" pb="3">{item?.meta?.activity_year}</Heading>
          <Heading size="3xl" color="b.bk" pb="8">{item.title}</Heading>
          <ActivityFullContent dangerouslySetInnerHTML={ {__html: item.content} } />
          <Divider mt="14" mb="14" color="b.lg" />
        </Box>
      ))
    }
    </>
  );
}

ParticipationContentItemActivityFull.defaultProps = {
};

export default ParticipationContentItemActivityFull;
